/**
 * @author Ivan Toth.
 */
var DetailLoadingController = (function () {
    function DetailLoadingController(topic, socket, $stateParams) {
        this.topic = topic;
        this.socket = socket;
        this.$stateParams = $stateParams;
        this.id = $stateParams.id;
    }
    DetailLoadingController.$inject = ['topic', 'socket', '$stateParams'];
    return DetailLoadingController;
}());
var DetailLoadingComponent = (function () {
    function DetailLoadingComponent() {
        this.templateUrl = 'detail-loading.html';
        this.controllerAs = 'vm';
        this.controller = DetailLoadingController;
    }
    return DetailLoadingComponent;
}());
angular
    .module('application')
    .component('loadingView', new DetailLoadingComponent());

//# sourceMappingURL=detail.loading.component.js.map
